import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class EmailEmbeddedImageSupportService {
  private url = 'email_embedded_image_support';
  constructor(private httpClient: HttpClientService) {}

  searchOptions(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }
  create(params: any = {}): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, params);
  }
  delete(params: any = {}): Promise<any> {
    return this.httpClient.delete(`${this.url}/${params.id}.json`);
  }
  update(params: any = {}): Promise<any> {
    return this.httpClient.put(`${this.url}/${params.id}.json`, params);
  }
  autocomplete(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/autocomplete_domain.json`, params);
  }
}
